import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import moment from 'moment';
import { Nav, NavItem, NavLink, TabContent, TabPane, Button, Badge, Table, Modal, ModalBody, ModalHeader } from 'reactstrap';
import {
  getWorkspaceMembers,
  getWorkspaceContacts,
  getWorkspaceDeals,
  getWorkspaceAgents,
  getWorkspaceActivity,
  getOwnerWorkspaces,
  getAccountAgents,
  getWorkspacePaymentHistory
} from '../../../store/Admin';
import './Workspaces.css';

const WorkspaceSidebar = ({ isOpen, onClose, workspace }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('members');
  const [loading, setLoading] = useState({});

  const {
    workspaceMembers = [],
    workspaceContacts = [],
    workspaceDeals = [],
    workspaceAgents = [],
    workspaceActivity = [],
    ownerWorkspaces = [],
    ownerWorkspacesData,
    accountAgentsData,
    workspacePaymentHistory,
    loadingMembers,
    loadingContacts,
    loadingDeals,
    loadingAgents,
    loadingActivity,
    loadingOwnerWorkspaces,
    loadingAccountAgents,
    loadingPaymentHistory
  } = useSelector((state) => {
    console.log('Full Admin state:', state.Admin);
    console.log('workspaceActivity from state:', state.Admin.workspaceActivity);
    console.log('loadingActivity from state:', state.Admin.loadingActivity);
    return state.Admin;
  });

  useEffect(() => {
    if (workspace && workspace._id && isOpen) {
      // Load initial data based on active tab
      loadTabData(activeTab);
    }
  }, [workspace, isOpen]);

  useEffect(() => {
    if (workspace && workspace._id && isOpen) {
      loadTabData(activeTab);
    }
  }, [activeTab]);

  const loadTabData = (tab) => {
    if (!workspace || !workspace._id) return;

    switch (tab) {
      case 'members':
        dispatch(getWorkspaceMembers({ id: workspace._id }));
        break;
      case 'contacts':
        dispatch(getWorkspaceContacts({ id: workspace._id }));
        break;
      case 'deals':
        dispatch(getWorkspaceDeals({ id: workspace._id }));
        break;
      case 'agents':
        dispatch(getWorkspaceAgents({ id: workspace._id }));
        break;
      case 'activity':
        console.log('Dispatching getWorkspaceActivity for workspace:', workspace._id);
        dispatch(getWorkspaceActivity({ id: workspace._id }));
        break;
      case 'workspaces':
        dispatch(getOwnerWorkspaces({ id: workspace._id }));
        break;
      case 'paymentHistory':
        dispatch(getWorkspacePaymentHistory({ id: workspace._id }));
        break;
      default:
        break;
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderMembersTab = () => (
    <div className='content-dashboard'>
      <div className="table-container filters-table">
        <div className='table-area'>
          {loadingMembers ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : workspaceMembers.length > 0 ? (
            <Table responsive hover className="mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Joined</th>
                </tr>
              </thead>
              <tbody>
                {workspaceMembers.map((member, index) => (
                  <tr key={index} className={member.isAdmin ? '' : ''}>
                    <td>
                      <div className="d-flex align-items-center">
                        {member.isAdmin && (
                          <i className="fa fa-crown mr-2 text-warning" title="Administrator"></i>
                        )}
                        <strong>
                          {member.userId ?
                            `${member.userId.firstName || ''} ${member.userId.lastName || ''}`.trim() || 'N/A'
                            : 'N/A'}
                        </strong>
                      </div>
                    </td>
                    <td>{member.email || (member.userId?.email) || 'N/A'}</td>
                    <td>
                      <Badge color={
                        member.role === 'admin' ? 'warning' :
                          member.role === 'owner' ? 'danger' :
                            'info'
                      }>
                        {member.role || 'member'}
                      </Badge>
                    </td>
                    <td>
                      <Badge color={member.status === 'active' ? 'success' : 'secondary'}>
                        {member.status || 'pending'}
                      </Badge>
                    </td>
                    <td>{moment(member.createdAt).format('MMM DD, YYYY')}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className='notfound-area'>
              <div className='img-box'>
                <img alt="..." src={require('../../../static/img/not-found.png')} />
              </div>
              <p>No members found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderContactsTab = () => (
    <div className='content-dashboard'>
      <div className="table-container filters-table">
        <div className='table-area'>
          {loadingContacts ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : workspaceContacts.length > 0 ? (
            <Table responsive hover className="mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Status</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                {workspaceContacts.map((contact, index) => (
                  <tr key={index}>
                    <td>{`${contact.firstName || ''} ${contact.lastName || ''}`.trim() || 'N/A'}</td>
                    <td>{contact.email || 'N/A'}</td>
                    <td>{contact.company || 'N/A'}</td>
                    <td>
                      <Badge color={
                        contact.status === 'active' ? 'success' :
                          contact.status === 'lead' ? 'info' :
                            contact.status === 'customer' ? 'primary' : 'secondary'
                      }>
                        {contact.status || 'active'}
                      </Badge>
                    </td>
                    <td>{moment(contact.createdAt).format('MMM DD, YYYY')}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className='notfound-area'>
              <div className='img-box'>
                <img alt="..." src={require('../../../static/img/not-found.png')} />
              </div>
              <p>No contacts found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderDealsTab = () => (
    <div className='content-dashboard'>
      <div className="table-container filters-table">
        <div className='table-area'>
          {loadingDeals ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : workspaceDeals.length > 0 ? (
            <Table responsive hover className="mb-0">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Amount</th>
                  <th>Stage</th>
                  <th>Pipeline</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                {workspaceDeals.map((deal, index) => (
                  <tr key={index}>
                    <td>{deal.title || 'N/A'}</td>
                    <td>${(deal.amount || 0).toLocaleString()}</td>
                    <td>
                      <Badge color="info">{deal.stage || 'N/A'}</Badge>
                    </td>
                    <td>{deal.pipelineId?.name || 'N/A'}</td>
                    <td>{moment(deal.createdAt).format('MMM DD, YYYY')}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className='notfound-area'>
              <div className='img-box'>
                <img alt="..." src={require('../../../static/img/not-found.png')} />
              </div>
              <p>No deals found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderAgentsTab = () => {
    return (
      <div className='content-dashboard'>
        <div className="table-container filters-table">
          <div className='table-area'>
            {loadingAgents ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : workspaceAgents.length > 0 ? (
              <Table responsive hover className="mb-0">
                <thead>
                  <tr>
                    <th>Agent Name</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Call Stats</th>
                    <th>Tags</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {workspaceAgents.map((agent, index) => (
                    <tr key={index}>
                      <td>
                        <i className="fa fa-robot mr-2 text-info"></i>
                        <strong>{agent.name || 'Unnamed Agent'}</strong>
                      </td>
                      <td>
                        <Badge color="primary" className="text-capitalize">
                          {agent.type || 'Single Prompt'}
                        </Badge>
                      </td>
                      <td>
                        <Badge color={agent.status === 'active' ? 'success' : 'secondary'}>
                          {agent.status || 'inactive'}
                        </Badge>
                      </td>
                      <td>
                        {agent.callStats ? (
                          <div>
                            <small>Total: {agent.callStats.totalCalls || 0}</small><br />
                            <small>Success: {agent.callStats.successRate || 0}%</small>
                          </div>
                        ) : (
                          <small className="text-muted">No calls yet</small>
                        )}
                      </td>
                      <td>
                        {agent.tags && agent.tags.length > 0 ? (
                          agent.tags.map((tag, idx) => (
                            <Badge key={idx} color="light" className="mr-1">
                              {tag}
                            </Badge>
                          ))
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>{moment(agent.createdAt).format('MMM DD, YYYY')}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className='notfound-area'>
                <div className='img-box'>
                  <img alt="..." src={require('../../../static/img/not-found.png')} />
                </div>
                <p>No agents found in this workspace</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderWorkspacesTab = () => {
    // Extract owner email and total workspaces from the response
    const ownerEmail = ownerWorkspacesData?.ownerEmail;
    const totalWorkspaces = ownerWorkspacesData?.totalWorkspaces;

    return (
      <div className='content-dashboard'>
        <div className="table-container filters-table workspaces-table-user">
          <div className='table-area'>
            {loadingOwnerWorkspaces ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {ownerEmail && (
                  <div className='function-box table-owner-area'>
                    <div className="user-info">
                      <div className="user-title-section">
                        <h3 className="user-name">
                          <i className="icon">
                            <svg fill="currentColor" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                              <path id="Mail" stroke="currentColor" d="M58.0034485,8H5.9965506c-3.3136795,0-5.9999995,2.6862001-5.9999995,6v36c0,3.3137016,2.6863203,6,5.9999995,6
                                h52.006897c3.3137016,0,6-2.6862984,6-6V14C64.0034485,10.6862001,61.3171501,8,58.0034485,8z M62.0034485,49.1108017
                                L43.084549,30.1919994l18.9188995-12.0555992V49.1108017z M5.9965506,10h52.006897c2.2056007,0,4,1.7943001,4,4v1.7664003
                                L34.4677505,33.3134003c-1.4902,0.9492989-3.3935013,0.9199982-4.8495998-0.0703011L1.9965508,14.4694996V14
                                C1.9965508,11.7943001,3.7910507,10,5.9965506,10z M1.9965508,16.8852005L21.182251,29.9251003L1.9965508,49.1108017V16.8852005z
                                M58.0034485,54H5.9965506c-1.6473999,0-3.0638998-1.0021019-3.6760998-2.4278984l20.5199013-20.5200024l5.6547985,3.843401
                                c1.0859013,0.7383003,2.3418007,1.1083984,3.5995998,1.1083984c1.1953011,0,2.3925018-0.3339996,3.4463005-1.0048981
                                l5.8423996-3.7230015l20.2961006,20.2961025C61.0673485,52.9978981,59.6508713,54,58.0034485,54z"/>
                            </svg>
                          </i>
                          <b>Account Email: </b> {ownerEmail}
                        </h3>
                        <span>
                          <Badge color="primary" className="px-3 py-2">
                            Total Workspaces: {totalWorkspaces || ownerWorkspaces.length}
                          </Badge>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {ownerWorkspaces.length > 0 ? (
                  <Table responsive hover className="mb-0">
                    <thead>
                      <tr>
                        <th>Workspace Name</th>
                        <th>ID</th>
                        <th>Status</th>
                        <th>Plan</th>
                        <th>Members</th>
                        <th>Agents</th>
                        <th>Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ownerWorkspaces.map((ws, index) => (
                        <tr key={index} className={ws.isCurrentWorkspace ? 'table-active' : ''}>
                          <td>
                            <strong>{ws.name || 'N/A'}</strong>
                            {ws.isCurrentWorkspace && (
                              <Badge color="info" className="ml-2">Current</Badge>
                            )}
                          </td>
                          <td><small className="text-muted">{ws.id || ws._id}</small></td>
                          <td>
                            <Badge color={
                              ws.status === 'active' ? 'success' :
                                ws.status === 'suspended' ? 'warning' :
                                  ws.status === 'trial' ? 'info' : 'secondary'
                            }>
                              {ws.status || 'active'}
                            </Badge>
                          </td>
                          <td>
                            <Badge color={ws.currentSubscription?.planName === 'Free' ? 'secondary' : 'primary'}>
                              {ws.currentSubscription?.planName || 'Free'}
                            </Badge>
                          </td>
                          <td>
                            <Badge color="light" className="text-dark">
                              {ws.memberCount || 0}
                            </Badge>
                          </td>
                          <td>
                            <Badge color="light" className="text-dark">
                              {ws.agentCount || 0}
                            </Badge>
                          </td>
                          <td>{moment(ws.createdAt).format('MMM DD, YYYY')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <div className='notfound-area'>
                    <div className='img-box'>
                      <img alt="..." src={require('../../../static/img/not-found.png')} />
                    </div>
                    <p>No workspaces found for this account</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderPaymentHistoryTab = () => {
    const paymentData = workspacePaymentHistory;

    return (
      <div className='content-dashboard'>

        <div className="table-container filters-table workspaces-table-user">
          <div className='table-area'>
            {loadingPaymentHistory ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {paymentData && (
                  <div className='function-box workspace-area payment-boxes-sidebar'>

                    <div className="user-info mb-3">
                      <div className="user-title-section">
                        <span title="Remaining Credits">
                          <i className="icon">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.1" cx="16" cy="16" r="16" fill="#DF9524"></circle><path d="M16.9334 19.6133H15.2601C14.1668 19.6133 13.2801 18.6933 13.2801 17.56C13.2801 17.2867 13.5068 17.06 13.7801 17.06C14.0534 17.06 14.2801 17.2867 14.2801 17.56C14.2801 18.14 14.7201 18.6133 15.2601 18.6133H16.9334C17.3668 18.6133 17.7268 18.2267 17.7268 17.76C17.7268 17.18 17.5201 17.0667 17.1801 16.9467L14.4934 16C13.9734 15.82 13.2734 15.4333 13.2734 14.24C13.2734 13.2133 14.0801 12.3867 15.0668 12.3867H16.7401C17.8334 12.3867 18.7201 13.3067 18.7201 14.44C18.7201 14.7133 18.4934 14.94 18.2201 14.94C17.9468 14.94 17.7201 14.7133 17.7201 14.44C17.7201 13.86 17.2801 13.3867 16.7401 13.3867H15.0668C14.6334 13.3867 14.2734 13.7733 14.2734 14.24C14.2734 14.82 14.4801 14.9333 14.8201 15.0533L17.5068 16C18.0268 16.18 18.7268 16.5667 18.7268 17.76C18.7201 18.78 17.9201 19.6133 16.9334 19.6133Z" fill="#DF9524"></path><path d="M16 20.5C15.7267 20.5 15.5 20.2733 15.5 20V12C15.5 11.7267 15.7267 11.5 16 11.5C16.2733 11.5 16.5 11.7267 16.5 12V20C16.5 20.2733 16.2733 20.5 16 20.5Z" fill="#DF9524"></path><path d="M16.0002 23.1667C12.0468 23.1667 8.8335 19.9533 8.8335 16C8.8335 12.0467 12.0468 8.83333 16.0002 8.83333C19.9535 8.83333 23.1668 12.0467 23.1668 16C23.1668 19.9533 19.9535 23.1667 16.0002 23.1667ZM16.0002 9.83333C12.6002 9.83333 9.8335 12.6 9.8335 16C9.8335 19.4 12.6002 22.1667 16.0002 22.1667C19.4002 22.1667 22.1668 19.4 22.1668 16C22.1668 12.6 19.4002 9.83333 16.0002 9.83333Z" fill="#DF9524"></path></svg>
                          </i>
                          Remaining Credits
                        </span>
                        <h3 className="user-name">
                          ${paymentData.remainingCredits?.creditsBalance || 0}
                        </h3>
                        <small>{paymentData.remainingCredits?.planName} Plan</small>
                      </div>
                    </div>
                    <div className="user-info mb-3">
                      <div className="user-title-section">
                        <span title="Free Minutes">
                          <i className="icon">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.1" cx="16" cy="16" r="16" fill="#FF7A59"></circle><path d="M15.9989 23.1667C15.5989 23.1667 15.2055 23.0734 14.8855 22.8934L11.7322 21.0734C10.4255 20.1934 10.3389 20.0334 10.3389 18.6534V15.3467C10.3389 13.9667 10.4255 13.8067 11.7055 12.9467L14.8922 11.1067C15.5255 10.74 16.4789 10.74 17.1122 11.1067L20.2655 12.9267C21.5722 13.8067 21.6589 13.9667 21.6589 15.3467V18.6534C21.6589 20.0334 21.5722 20.1934 20.2922 21.0534L17.1055 22.8934C16.7922 23.08 16.3922 23.1667 15.9989 23.1667ZM15.9989 11.8334C15.7722 11.8334 15.5455 11.88 15.3855 11.9734L12.2322 13.7934C11.3389 14.4 11.3389 14.4 11.3389 15.3467V18.6534C11.3389 19.6 11.3389 19.6 12.2655 20.2267L15.3922 22.0267C15.7122 22.2134 16.2922 22.2134 16.6122 22.0267L19.7655 20.2067C20.6589 19.6 20.6589 19.6 20.6589 18.6534V15.3467C20.6589 14.4 20.6589 14.4 19.7322 13.7734L16.6055 11.9734C16.4522 11.88 16.2255 11.8334 15.9989 11.8334Z" fill="#FF7A59"></path><path d="M19.6654 13.5867C19.392 13.5867 19.1654 13.36 19.1654 13.0867V11.3333C19.1654 10.28 18.7187 9.83334 17.6654 9.83334H14.332C13.2787 9.83334 12.832 10.28 12.832 11.3333V13.04C12.832 13.3133 12.6054 13.54 12.332 13.54C12.0587 13.54 11.832 13.32 11.832 13.04V11.3333C11.832 9.72001 12.7187 8.83334 14.332 8.83334H17.6654C19.2787 8.83334 20.1654 9.72001 20.1654 11.3333V13.0867C20.1654 13.36 19.9387 13.5867 19.6654 13.5867Z" fill="#FF7A59"></path><path d="M17.0855 19.7534C16.9455 19.7534 16.7989 19.7267 16.6522 19.6667L15.9989 19.4134L15.3455 19.6734C14.9922 19.8134 14.6322 19.7801 14.3655 19.5867C14.0989 19.3934 13.9589 19.0601 13.9789 18.6801L14.0189 17.9801L13.5722 17.4401C13.3322 17.1401 13.2522 16.7934 13.3589 16.4734C13.4589 16.1601 13.7322 15.9201 14.0989 15.8267L14.7789 15.6534L15.1589 15.0601C15.5655 14.4201 16.4389 14.4201 16.8455 15.0601L17.2255 15.6534L17.9055 15.8267C18.2722 15.9201 18.5455 16.1601 18.6455 16.4734C18.7455 16.7867 18.6655 17.1401 18.4255 17.4334L17.9789 17.9734L18.0189 18.6734C18.0389 19.0534 17.8989 19.3801 17.6322 19.5801C17.4722 19.6934 17.2855 19.7534 17.0855 19.7534ZM14.3455 16.8001L14.7922 17.3401C14.9455 17.5201 15.0322 17.8067 15.0189 18.0401L14.9789 18.7401L15.6322 18.4801C15.8522 18.3934 16.1455 18.3934 16.3655 18.4801L17.0189 18.7401L16.9789 18.0401C16.9655 17.8067 17.0522 17.5267 17.2055 17.3401L17.6522 16.8001L16.9722 16.6267C16.7455 16.5667 16.5055 16.3934 16.3789 16.2001L16.0055 15.6134L15.6255 16.2001C15.4989 16.4001 15.2589 16.5734 15.0322 16.6334L14.3455 16.8001Z" fill="#FF7A59"></path></svg>
                          </i>
                          Free Minutes
                        </span>
                        <h3 className="user-name">{paymentData.remainingCredits?.freeMinutes || 0}</h3>
                        <small>Minutes remaining</small>
                      </div>
                    </div>

                    <div className="user-info mb-3">
                      <div className="user-title-section">
                        <span title="Total Spent">
                          <i className="icon">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.1" cx="16" cy="16" r="16" fill="#9333EA"></circle><path d="M15.9989 23.1667C13.3322 23.1667 11.1655 21.2533 11.1655 18.9V16.4333C11.1655 16.16 11.3922 15.9333 11.6655 15.9333C11.9389 15.9333 12.1655 16.16 12.1655 16.4333C12.1655 18.18 13.8122 19.5 15.9989 19.5C18.1855 19.5 19.8322 18.18 19.8322 16.4333C19.8322 16.16 20.0589 15.9333 20.3322 15.9333C20.6055 15.9333 20.8322 16.16 20.8322 16.4333V18.9C20.8322 21.2533 18.6655 23.1667 15.9989 23.1667ZM12.1655 18.9733C12.2122 20.74 13.9122 22.1667 15.9989 22.1667C18.0855 22.1667 19.7855 20.74 19.8322 18.9733C18.9655 19.9133 17.5922 20.5 15.9989 20.5C14.4055 20.5 13.0389 19.9133 12.1655 18.9733Z" fill="#9333EA"></path><path d="M15.9989 17.1667C14.1589 17.1667 12.5055 16.34 11.6989 15.0067C11.3522 14.44 11.1655 13.78 11.1655 13.1C11.1655 11.9533 11.6789 10.8733 12.6055 10.06C13.5122 9.26666 14.7189 8.83333 15.9989 8.83333C17.2789 8.83333 18.4789 9.26666 19.3922 10.0533C20.3189 10.8733 20.8322 11.9533 20.8322 13.1C20.8322 13.78 20.6455 14.4333 20.2989 15.0067C19.4922 16.34 17.8389 17.1667 15.9989 17.1667ZM15.9989 9.83333C14.9589 9.83333 13.9855 10.18 13.2589 10.82C12.5522 11.4333 12.1655 12.2467 12.1655 13.1C12.1655 13.6 12.2989 14.0667 12.5522 14.4867C13.1855 15.5267 14.5055 16.1667 15.9989 16.1667C17.4922 16.1667 18.8122 15.52 19.4455 14.4867C19.7055 14.0667 19.8322 13.6 19.8322 13.1C19.8322 12.2467 19.4455 11.4333 18.7322 10.8067C18.0055 10.18 17.0389 9.83333 15.9989 9.83333Z" fill="#9333EA"></path><path d="M15.9989 20.5C13.2455 20.5 11.1655 18.7533 11.1655 16.4333V13.1C11.1655 10.7467 13.3322 8.83333 15.9989 8.83333C17.2789 8.83333 18.4789 9.26666 19.3922 10.0533C20.3189 10.8733 20.8322 11.9533 20.8322 13.1V16.4333C20.8322 18.7533 18.7522 20.5 15.9989 20.5ZM15.9989 9.83333C13.8855 9.83333 12.1655 11.3 12.1655 13.1V16.4333C12.1655 18.18 13.8122 19.5 15.9989 19.5C18.1855 19.5 19.8322 18.18 19.8322 16.4333V13.1C19.8322 12.2467 19.4455 11.4333 18.7322 10.8067C18.0055 10.18 17.0389 9.83333 15.9989 9.83333Z" fill="#9333EA"></path></svg>
                          </i>
                          Total Spent
                        </span>
                        <h3 className="user-name">${paymentData.totalSpent || 0}</h3>
                        <small>All time</small>
                      </div>
                    </div>
                  </div>
                )}
                {paymentData?.payments?.length > 0 ? (
                  <>
                    <h5 className="mb-3 ml-3">Payment History</h5>
                    <Table responsive hover className="mb-0">
                      <thead>
                        <tr>
                          <th>Invoice #</th>
                          <th>Amount</th>
                          <th>Type</th>
                          <th>Status</th>
                          <th>Description</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentData.payments.map((payment, index) => (
                          <tr key={index}>
                            <td>{payment.invoiceNumber || '-'}</td>
                            <td>
                              <strong>${payment.amount} {payment.currency}</strong>
                            </td>
                            <td>
                              <Badge color="info" className="text-capitalize">
                                {payment.type}
                              </Badge>
                            </td>
                            <td>
                              <Badge color={
                                payment.status === 'succeeded' ? 'success' :
                                  payment.status === 'pending' ? 'warning' :
                                    payment.status === 'failed' ? 'danger' : 'secondary'
                              }>
                                {payment.status}
                              </Badge>
                            </td>
                            <td>{payment.description || '-'}</td>
                            <td>{moment(payment.paidAt || payment.createdAt).format('MMM DD, YYYY')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </>
                ) : (
                  <div className='notfound-area'>
                    <div className='img-box'>
                      <img alt="..." src={require('../../../static/img/not-found.png')} />
                    </div>
                    <p>No payment history found</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Helper functions for activity display - matching Dashboard and User activity style
  const getActivityIcon = (type) => {
    const icons = {
      'user_created': 'fa-user-plus',
      'user_updated': 'fa-user-edit',
      'user_deleted': 'fa-user-times',
      'workspace_created': 'fa-building',
      'workspace_updated': 'fa-edit',
      'workspace_suspended': 'fa-pause-circle',
      'workspace_deleted': 'fa-trash-alt',
      'agent_created': 'fa-robot',
      'agent_started': 'fa-play-circle',
      'agent_stopped': 'fa-stop-circle',
      'agent_deleted': 'fa-trash-alt',
      'system_backup': 'fa-database',
      'system_update': 'fa-sync-alt',
      'system_error': 'fa-exclamation-triangle',
      'login_success': 'fa-sign-in-alt',
      'login_failed': 'fa-times-circle',
      'subscription_created': 'fa-credit-card',
      'subscription_upgraded': 'fa-arrow-up',
      'subscription_cancelled': 'fa-times',
      'payment_success': 'fa-dollar-sign',
      'payment_failed': 'fa-exclamation-circle',
      'security_alert': 'fa-shield-alt',
      'api_key_created': 'fa-key',
      'api_key_revoked': 'fa-ban',
      'authentication': 'fa-lock',
      'contact': 'fa-address-book',
      'deal': 'fa-handshake-o',
      'email': 'fa-envelope',
      'call': 'fa-phone'
    };
    return icons[type] || 'fa-info-circle';
  };

  const getActivityColor = (severity) => {
    const colors = { 'success': 'text-success', 'info': 'text-info', 'warning': 'text-warning', 'error': 'text-danger', 'critical': 'text-danger' };
    return colors[severity] || 'text-secondary';
  };

  const getRelativeTime = (timestamp) => {
    const diffMs = Date.now() - new Date(timestamp).getTime();
    const sec = Math.floor(diffMs / 1000);
    if (sec < 60) return `${sec}s ago`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min}m ago`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h ago`;
    const day = Math.floor(hr / 24);
    return `${day}d ago`;
  };

  const renderActivityTab = () => {
    console.log('=== COMPONENT renderActivityTab ===');
    console.log('loadingActivity:', loadingActivity);
    console.log('workspaceActivity:', workspaceActivity);
    console.log('workspaceActivity is array?', Array.isArray(workspaceActivity));
    console.log('workspaceActivity length:', workspaceActivity?.length);

    return (
      <div className='content-dashboard mt-3'>
        <h6>Recent Activity</h6>
        <div className="activity-list" style={{ maxHeight: '500px', overflowY: 'auto' }}>
          {loadingActivity ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {(workspaceActivity && workspaceActivity.length > 0 ? workspaceActivity : []).map(activity => (
                <div key={activity['_id']} className="activity-item mb-3 pb-2 border-bottom">
                  <div className="d-flex align-items-start">
                    <div className="activity-icon">
                      <i className={`fa ${getActivityIcon(activity['type'])} ${getActivityColor(activity['severity'])}`}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="activity-content">
                        <p className="mb-1 small">
                          <strong>{activity['actor']?.['name'] || activity['actor']?.['email'] || 'User'}</strong> {activity['action']}
                          {activity['workspace'] && (
                            <span>&nbsp;in <strong>{activity['workspace']['name']}</strong></span>
                          )}
                        </p>
                        <small className="text-muted">
                          <i className="fa fa-clock mr-1"></i>
                          {getRelativeTime(activity['timestamp'])}
                          {activity['target']?.['type'] && (
                            <span className="ml-2">
                              <Badge color="secondary" className="badge-sm">{activity['target']['type']}</Badge>
                            </span>
                          )}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {(!workspaceActivity || workspaceActivity.length === 0) && (
                <div className="text-center text-muted py-4">
                  <i className="fa fa-clock fa-2x mb-2 d-block"></i>
                  <p>No recent activity found for this workspace</p>
                  <small>Activities will appear here when actions are performed</small>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  if (!isOpen) return null;

  return (
    <>
      <Modal isOpen={isOpen} modalClassName='right right-without-bg' backdrop={false} className={`main-modal right right-side-modal style-three`}>
        <ModalHeader toggle={onClose}>
          <h3>{workspace?.name || 'Workspace Details'}
            <Badge
              color={workspace?.status === 'active' ? 'success' : workspace?.status === 'suspended' ? 'warning' : 'secondary'}
              className="status-badge"
            >
              {workspace?.status || 'Active'}
            </Badge>
          </h3>
        </ModalHeader>
        <ModalBody>
          <div className='filters-modal-content'>
            <div className='function-box workspace-area'>

              <div className="user-info">
                <div className="user-title-section">
                  <h3 className="user-name">
                    <i className="icon">
                      <svg fill="currentColor" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                        <path id="Mail" stroke="currentColor" d="M58.0034485,8H5.9965506c-3.3136795,0-5.9999995,2.6862001-5.9999995,6v36c0,3.3137016,2.6863203,6,5.9999995,6
                                h52.006897c3.3137016,0,6-2.6862984,6-6V14C64.0034485,10.6862001,61.3171501,8,58.0034485,8z M62.0034485,49.1108017
                                L43.084549,30.1919994l18.9188995-12.0555992V49.1108017z M5.9965506,10h52.006897c2.2056007,0,4,1.7943001,4,4v1.7664003
                                L34.4677505,33.3134003c-1.4902,0.9492989-3.3935013,0.9199982-4.8495998-0.0703011L1.9965508,14.4694996V14
                                C1.9965508,11.7943001,3.7910507,10,5.9965506,10z M1.9965508,16.8852005L21.182251,29.9251003L1.9965508,49.1108017V16.8852005z
                                M58.0034485,54H5.9965506c-1.6473999,0-3.0638998-1.0021019-3.6760998-2.4278984l20.5199013-20.5200024l5.6547985,3.843401
                                c1.0859013,0.7383003,2.3418007,1.1083984,3.5995998,1.1083984c1.1953011,0,2.3925018-0.3339996,3.4463005-1.0048981
                                l5.8423996-3.7230015l20.2961006,20.2961025C61.0673485,52.9978981,59.6508713,54,58.0034485,54z"/>
                      </svg>
                    </i>
                    Email
                  </h3>
                  <span title={workspace?.owner?.email || workspace?.createdBy?.email || 'N/A'}>
                    {workspace?.owner?.email || workspace?.createdBy?.email || 'N/A'}
                  </span>
                </div>
              </div>

              <div className="user-info">
                <div className="user-title-section">
                  <h3 className="user-name">
                    <i className="icon">
                      <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 21C5 17.134 8.13401 14 12 14C15.866 14 19 17.134 19 21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </i>
                    Owner
                  </h3>
                  <span title={workspace?.owner ?
                    `${workspace.owner.firstName || ''} ${workspace.owner.lastName || ''}`.trim() || 'N/A' :
                    workspace?.createdBy ?
                      `${workspace.createdBy.firstName || ''} ${workspace.createdBy.lastName || ''}`.trim() || 'N/A' :
                      'N/A'}>
                    {workspace?.owner ?
                      `${workspace.owner.firstName || ''} ${workspace.owner.lastName || ''}`.trim() || 'N/A' :
                      workspace?.createdBy ?
                        `${workspace.createdBy.firstName || ''} ${workspace.createdBy.lastName || ''}`.trim() || 'N/A' :
                        'N/A'
                    }
                  </span>
                </div>
              </div>
              <div className="user-info">
                <div className="user-title-section">
                  <h3 className="user-name">
                    <i class="fa fa-calendar mr-2"></i>
                    Created
                  </h3>
                  <span>{workspace?.createdAt ? moment(workspace.createdAt).format('MMM DD, YYYY') : 'N/A'}</span>
                </div>
              </div>

              <div className="user-info">
                <div className="user-title-section">
                  <h3 className="user-name">
                    <i class="fa fa-building mr-2"></i>
                    Plan
                  </h3>
                  <Badge color={workspace?.plan === 'Free' || workspace?.subscription?.planName === 'Free' ? 'secondary' : 'primary'}>
                    {workspace?.plan || workspace?.subscription?.planName || 'Free'}
                  </Badge>
                </div>
              </div>
            </div>

            <div className='function-box workspace-area-detail mt-3'>
              <div className="sidebar-body">
                <div className='tabs-area'>
                  {/* Navigation Tabs */}
                  <div className='tab-header'>
                    {/* Navigation Tabs */}
                    <Nav tabs className="workspace-tabs">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === 'members' })}
                          onClick={() => toggle('members')}
                        >
                          Members
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === 'contacts' })}
                          onClick={() => toggle('contacts')}
                        >
                          Contacts
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === 'deals' })}
                          onClick={() => toggle('deals')}
                        >
                          Deals
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === 'agents' })}
                          onClick={() => toggle('agents')}
                        >
                          Agents
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === 'workspaces' })}
                          onClick={() => toggle('workspaces')}
                        >
                          Workspaces
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === 'paymentHistory' })}
                          onClick={() => toggle('paymentHistory')}
                        >
                          Payment History
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === 'activity' })}
                          onClick={() => toggle('activity')}
                        >
                          Recent Activity
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </div>

                <TabContent activeTab={activeTab}>
                  <TabPane tabId="members">
                    {renderMembersTab()}
                  </TabPane>
                  <TabPane tabId="contacts">
                    {renderContactsTab()}
                  </TabPane>
                  <TabPane tabId="deals">
                    {renderDealsTab()}
                  </TabPane>
                  <TabPane tabId="agents">
                    {renderAgentsTab()}
                  </TabPane>
                  <TabPane tabId="workspaces">
                    {renderWorkspacesTab()}
                  </TabPane>
                  <TabPane tabId="paymentHistory">
                    {renderPaymentHistoryTab()}
                  </TabPane>
                  <TabPane tabId="activity">
                    {renderActivityTab()}
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* <div className={`workspace-details-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <Button
            color="link"
            className="close-btn"
            onClick={onClose}
          >
            <i className="fa fa-times"></i>
          </Button>

          <div className="workspace-info">
            <div className="workspace-title-section">
              <h3 className="workspace-name">
                <i className="fa fa-building-o mr-2 text-primary"></i>
                {workspace?.name || 'Workspace Details'}
              </h3>
              <Badge
                color={workspace?.status === 'active' ? 'success' : workspace?.status === 'suspended' ? 'warning' : 'secondary'}
                className="status-badge"
              >
                {workspace?.status || 'Active'}
              </Badge>
            </div>

            <div className="workspace-meta-grid">
              <div className="meta-card">
                <div className="meta-icon">
                  <i className="fa fa-envelope-o"></i>
                </div>
                <div className="meta-content">
                  <label>Email:</label>
                  <span title={workspace?.owner?.email || workspace?.createdBy?.email || 'N/A'}>
                    {workspace?.owner?.email || workspace?.createdBy?.email || 'N/A'}
                  </span>
                </div>
              </div>

              <div className="meta-card">
                <div className="meta-icon">
                  <i className="fa fa-user"></i>
                </div>
                <div className="meta-content">
                  <label>Owner:</label>
                  <span title={workspace?.owner ?
                    `${workspace.owner.firstName || ''} ${workspace.owner.lastName || ''}`.trim() || 'N/A' :
                    workspace?.createdBy ?
                      `${workspace.createdBy.firstName || ''} ${workspace.createdBy.lastName || ''}`.trim() || 'N/A' :
                      'N/A'}>
                    {workspace?.owner ?
                      `${workspace.owner.firstName || ''} ${workspace.owner.lastName || ''}`.trim() || 'N/A' :
                      workspace?.createdBy ?
                        `${workspace.createdBy.firstName || ''} ${workspace.createdBy.lastName || ''}`.trim() || 'N/A' :
                        'N/A'
                    }
                  </span>
                </div>
              </div>

              <div className="meta-card">
                <div className="meta-icon">
                  <i className="fa fa-calendar"></i>
                </div>
                <div className="meta-content">
                  <label>Created:</label>
                  <span>{workspace?.createdAt ? moment(workspace.createdAt).format('MMM DD, YYYY') : 'N/A'}</span>
                </div>
              </div>

              <div className="meta-card">
                <div className="meta-icon">
                  <i className="fa fa-diamond"></i>
                </div>
                <div className="meta-content">
                  <label>Plan:</label>
                  <Badge color={workspace?.plan === 'Free' || workspace?.subscription?.planName === 'Free' ? 'secondary' : 'primary'}>
                    {workspace?.plan || workspace?.subscription?.planName || 'Free'}
                  </Badge>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sidebar-body">
          <Nav tabs className="workspace-tabs">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'members' })}
                onClick={() => toggle('members')}
              >
                Members
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'contacts' })}
                onClick={() => toggle('contacts')}
              >
                Contacts
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'deals' })}
                onClick={() => toggle('deals')}
              >
                Deals
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'agents' })}
                onClick={() => toggle('agents')}
              >
                Agents
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'workspaces' })}
                onClick={() => toggle('workspaces')}
              >
                Workspaces
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'paymentHistory' })}
                onClick={() => toggle('paymentHistory')}
              >
                Payment History
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'activity' })}
                onClick={() => toggle('activity')}
              >
                Recent Activity
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="members">
              {renderMembersTab()}
            </TabPane>
            <TabPane tabId="contacts">
              {renderContactsTab()}
            </TabPane>
            <TabPane tabId="deals">
              {renderDealsTab()}
            </TabPane>
            <TabPane tabId="agents">
              {renderAgentsTab()}
            </TabPane>
            <TabPane tabId="workspaces">
              {renderWorkspacesTab()}
            </TabPane>
            <TabPane tabId="paymentHistory">
              {renderPaymentHistoryTab()}
            </TabPane>
            <TabPane tabId="activity">
              {renderActivityTab()}
            </TabPane>
          </TabContent>
        </div>
      </div> */}
    </>
  );
};

export default WorkspaceSidebar;